<script>
import Routable from "@mixins/routable";
import LuminanceMask from "@/components/ui/masks/LuminanceMask";

export default {
  name: "NationalFinalBtn",
  mixins: [Routable],
  computed: {
    classes() {
      return ["national-final", Routable.computed.classes.call(this)];
    }
  },
  render(h) {
    const { tag, data } = this.generateRouteLink();

    const content = (
      <div class="w-100">
        <div class="national-final__bg-wrapper">
          <LuminanceMask
            class="national-final__bg"
            src={require("@/assets/images/city/national-final-btn.jpg")}
          />
        </div>
        <div class="national-final__content">{this.$slots.default}</div>
      </div>
    );

    return h(tag, data, [content]);
  }
};
</script>

<style lang="scss">
$p: ".national-final";

.national-final {
  color: colors(palette-2);
  width: 100%;
  display: flex;
  align-items: center;
  height: 146px;
  position: relative;
  z-index: 1;
  padding: 5px 25px;
  letter-spacing: -0.05em;
  font-size: 60px;
  text-align: center;

  &__content {
    color: colors(text-3);
    text-transform: uppercase;
    font-weight: fw(bold);
    width: 100%;
    text-shadow: 0 0 5px colors(text-4);
  }

  &__bg {
    top: 0;
    left: 0;
    color: colors(text-4);
    width: 883px;
    height: 146px;
    position: absolute;
    transition: color 0.2s;
  }

  &__bg-wrapper {
    position: absolute;
    left: -10px;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: -1;
  }

  &:hover {
    text-decoration: none;
    #{$p}__bg {
      color: lighten(colors(text-4), 5%);
    }
  }

  &:active {
    text-decoration: none;
    #{$p}__bg {
      color: darken(colors(text-4), 5%);
    }
  }

  @include breakpoint("sm-only") {
    font-size: 45px;
  }

  @include breakpoint("xs-only") {
    font-size: 36px;
  }
}
</style>
